{
  "de": {
    "login": {
      "loginPupil": {
        "activeSession": {
          "confirm": "Einloggen",
          "text": "Du bist aktuell als Lehrkraft eingeloggt. Um den Zugangslink als Schüler*in zu nutzen, wirst du zuerst ausgeloggt.",
          "title": "Ausloggen und als Schüler*in einloggen?"
        },
        "appHandoff": {
          "continueInBrowser": "Im Browser fortfahren",
          "openApp": "In der App öffnen",
          "subtitle": "In der fobizz App öffnen?",
          "text": "Wenn du die fobizz App auf diesem Gerät hast, öffnet sich dein Klassenraum direkt dort. Sonst kannst du hier im Browser weitermachen."
        },
        "error": "Dieser Code ist leider nicht gültig. Hast du dich vielleicht vertippt?",
        "instruction": "Deinen Zugangscode erhältst du von deiner Lehrkraft.",
        "logIn": "Einloggen",
        "subtitle": "Gib deinen 6-stelligen Code hier ein",
        "title": "Als Schüler*in einloggen"
      },
      "loginTemporaryPupil": {
        "classFull": "Dieser Klassenraum ist leider schon voll. Bitte melde dich bei deiner Lehrkraft.",
        "error": "Dieser Link ist leider nicht mehr gültig.",
        "title": "Bitte warte, du wirst in Kürze eingeloggt..."
      }
    }
  }
}
